import React from "react";

export const Logo = () => {
  return <img src="logo.png" alt="Samgori Park" height={48} width={48} />;
};
